<template>
	<span class="content">
		<span style="color:white;font-weight:bold;">INFO: Nese deshironi qe te vazhdoni qe te jeni aktiv dhe pse hapni dhe programe tjera ne telefonin tuaj, mjafton qe ta leshoni radion dhe nuk do te largoheni nga CHATI. Radio leshohet automatik por nese nuk leshohet atehere klikoni ne anen e majt te telefonit te lista e bisedave e keni radion lart, klikoni PLAY dhe vazhdoni chatin pa nderprerje.</span>
	</span>
</template>

<script>
import localetime from "../../js/helpers/localetime";
import Username from "../Username.vue";

export default {
	name: "MessageTypeTopicSetBy",
	components: {
		Username,
	},
	props: {
		network: Object,
		message: Object,
	},
	computed: {
		messageTimeLocale() {
			return localetime(this.message.when);
		},
	},
};
</script>
